export default __webpack_public_path__ + "68198aec68427c996dc40fc2015fe441.jpg";